module.exports = __webpack_public_path__ + "static/img/06.65c0bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/jzjy/06.png
// module id = vQbS
// module chunks = 0